export class Permit {
    public dataType?: boolean;
    public import?: boolean;
    public schema?: boolean;
    public content?: boolean;
    public security?: boolean;

    constructor(source?: any) {
        if (source) {
            this.dataType = source.dataType;
            this.import = source.import;
            this.schema = source.schema;
            this.content = source.content;
            this.security = source.security;
        }
    }
}
